import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";

export const GameLeaderboards = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('weekly');

  const mockLeaderboard = [
    { rank: 1, name: "Maktum Talukdar", score: 12000, diamonds: 12000, avatar: "👑" },
    { rank: 2, name: "Sarah Johnson", score: 10500, diamonds: 10500, avatar: "🎸" },
    { rank: 3, name: "Mike Chen", score: 9800, diamonds: 9800, avatar: "🎹" },
    { rank: 4, name: "Emma Wilson", score: 8900, diamonds: 8900, avatar: "🎤" },
    { rank: 5, name: "Alex Kumar", score: 8200, diamonds: 8200, avatar: "🥁" },
    { rank: 6, name: "Lisa Park", score: 7500, diamonds: 7500, avatar: "🎺" },
    { rank: 7, name: "John Doe", score: 6800, diamonds: 6800, avatar: "🎵" },
    { rank: 8, name: "Amy Zhang", score: 6200, diamonds: 6200, avatar: "🎶" }
  ];

  return (
    <div className="game-leaderboards">
      <div className="leaderboards-container">
        <div className="leaderboards-header">
          <button
            onClick={onBack}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors mb-4"
            aria-label="Back"
          >
            <ChevronLeft size={24} className="text-white" />
          </button>
          <h2 className="text-2xl font-bold text-white mb-4">
            Leaderboards
          </h2>
          <div className="tab-selector">
            <button
              className={`tab-btn ${activeTab === 'daily' ? 'active' : ''}`}
              onClick={() => setActiveTab('daily')}
            >
              Daily
            </button>
            <button
              className={`tab-btn ${activeTab === 'weekly' ? 'active' : ''}`}
              onClick={() => setActiveTab('weekly')}
            >
              Weekly
            </button>
            <button
              className={`tab-btn ${activeTab === 'monthly' ? 'active' : ''}`}
              onClick={() => setActiveTab('monthly')}
            >
              Monthly
            </button>
            <button
              className={`tab-btn ${activeTab === 'alltime' ? 'active' : ''}`}
              onClick={() => setActiveTab('alltime')}
            >
              All Time
            </button>
          </div>
        </div>

        <div className="king-of-quiz">
          <div className="king-banner">
            <span className="crown-icon">👑</span>
            <div className="king-info">
              <p className="king-label">This week King of the Quiz</p>
              <h3 className="king-name">Maktum Talukdar</h3>
              <p className="king-score">12000 diamonds</p>
            </div>
          </div>
        </div>

        <div className="leaderboard-list">
          {mockLeaderboard.map((player) => (
            <div key={player.rank} className={`leaderboard-item rank-${player.rank}`}>
              <div className="rank-badge">
                {player.rank <= 3 ? (
                  <span className={`medal medal-${player.rank}`}>
                    {player.rank === 1 ? '🥇' : player.rank === 2 ? '🥈' : '🥉'}
                  </span>
                ) : (
                  <span className="rank-number">#{player.rank}</span>
                )}
              </div>
              <div className="player-info">
                <span className="player-avatar">{player.avatar}</span>
                <span className="player-name">{player.name}</span>
              </div>
              <div className="player-score">
                <span className="score-value">{player.score.toLocaleString()}</span>
                <span className="diamonds">💎 {player.diamonds.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="your-ranking">
          <div className="your-rank-card">
            <p className="your-rank-label">Your Ranking</p>
            <div className="your-rank-info">
              <span className="your-position">#42</span>
              <span className="your-score">2,500 points</span>
              <span className="your-diamonds">💎 2,500</span>
            </div>
            <button className="btn-improve">Improve Ranking</button>
          </div>
        </div>
      </div>
    </div>
  );
};